import http from './httpService'; 
const apiUrl = process.env.REACT_APP_API_URL;
const apiEndpoint = apiUrl + "/places";
  export function searchPlaces(body) {
   const { textQuery, lat, long, radius = 100000 } = body;
   console.log(body);
   return http.post(apiEndpoint,  { textQuery, lat, long, radius });
 }
